import React, { createContext, useContext, useMemo } from "react";
import { collection, limit, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import { useLiveQuery } from "../../hooks/useLive";

// Only small collections are loaded up front: distributors, portal logins
// and the latest activity. Keys and customers are read a page at a time
// (lib/queries.js), with counts done by Firestore, so the portal starts the
// same way whether there are a thousand keys or a million.
const AdminDataContext = createContext(null);

export const useAdminData = () => useContext(AdminDataContext);

export function AdminDataProvider({ children }) {
  const distributors = useLiveQuery("distributors", () =>
    collection(db, "distributors"),
  );
  const users = useLiveQuery("users", () => collection(db, "users"));
  const activity = useLiveQuery("activity", () =>
    query(collection(db, "activity"), orderBy("at", "desc"), limit(50)),
  );

  const value = useMemo(() => {
    const sortedDistributors = [...distributors.data].sort((a, b) =>
      (a.name || "").localeCompare(b.name || ""),
    );
    return {
      distributors: sortedDistributors,
      distributorsLoading: distributors.loading,
      distributorById: Object.fromEntries(
        sortedDistributors.map((d) => [d.id, d]),
      ),
      users: users.data,
      activity: activity.data,
      activityLoading: activity.loading,
    };
  }, [distributors, users, activity]);

  return (
    <AdminDataContext.Provider value={value}>
      {children}
    </AdminDataContext.Provider>
  );
}
